export const PAYOUTS_CURRENCIES = {
    ['AED']: {
        code: 'aed',
        name: 'United Arab Emirates Dirham',
    },
    ['ARS']: {
        code: 'ars',
        name: 'Argentine Peso',
    },
    ['AUD']: {
        code: 'aud',
        name: 'Australian Dollar',
    },
    ['BOB']: {
        code: 'BOB',
        name: 'Bolivian Boliviano',
    },
    ['BGN']: {
        code: 'BGN',
        name: 'Bulgarian Lev',
    },
    ['BRL']: {
        code: 'BRL',
        name: 'Brazilian Real',
    },
    ['CAD']: {
        code: 'cad',
        name: 'Canadian Dollar',
    },
    ['CHF']: {
        code: 'chf',
        name: 'Swiss Franc',
    },
    ['CLP']: {
        code: 'clp',
        name: 'Chilean Peso',
    },
    ['COP']: {
        code: 'cop',
        name: 'Columbian Peso',
    },
    ['CRC']: {
        code: 'crc',
        name: 'Costa Rican Colón',
    },
    ['CZK']: {
        code: 'czk',
        name: 'Czech Koruna',
    },
    ['DKK']: {
        code: 'dkk',
        name: 'Danish Krone',
    },
    ['DOP']: {
        code: 'dop',
        name: 'Dominican Peso',
    },
    ['EGP']: {
        code: 'egp',
        name: 'Egyptian Pound',
    },
    ['EUR']: {
        code: 'eur',
        name: 'Euro',
    },
    ['GBP']: {
        code: 'gbp',
        name: 'British Pound Sterling',
    },
    ['HKD']: {
        code: 'hkd',
        name: 'Hong Kong Dollar',
    },
    ['HRK']: {
        code: 'hrk',
        name: 'Croatian Kuna',
    },
    ['HUF']: {
        code: 'huf',
        name: 'Hungarian Forint',
    },
    ['IDR']: {
        code: 'idr',
        name: 'Indonesian Rupiah',
    },
    ['ILS']: {
        code: 'ils',
        name: 'Israeli New Shekel',
    },
    ['INR']: {
        code: 'inr',
        name: 'Indian Rupee',
    },
    ['JPY']: {
        code: 'jpy',
        name: 'Japanese Yen',
    },
    ['MYR']: {
        code: 'myr',
        name: 'Malaysian Ringgit',
    },
    ['MXN']: {
        code: 'mxn',
        name: 'Mexican Peso',
    },
    ['NOK']: {
        code: 'nok',
        name: 'Norwegian Krone',
    },
    ['NZD']: {
        code: 'nzd',
        name: 'New Zealand Dollar',
    },
    ['PEN']: {
        code: 'pen',
        name: 'Peruvian Sol',
    },
    ['PLN']: {
        code: 'pln',
        name: 'Polish Złoty',
    },
    ['PYG']: {
        code: 'pyg',
        name: 'Paraguayan Guarani',
    },
    ['RON']: {
        code: 'ron',
        name: 'Romanian Leu',
    },
    ['SEK']: {
        code: 'sek',
        name: 'Swedish Krona',
    },
    ['SGD']: {
        code: 'sgd',
        name: 'Singapore Dollar',
    },
    ['THB']: {
        code: 'thb',
        name: 'Thai Baht',
    },
    ['TTD']: {
        code: 'ttd',
        name: 'Trinidad & Tobago Dollar',
    },
    ['USD']: {
        code: 'usd',
        name: 'United States Dollar',
    },
    ['UYU']: {
        code: 'uyu',
        name: 'Uruguayan Peso',
    },
};
export const PAYOUTS_COUNTRY_CURRENCIES = {
    'AR': {
        name: 'Argentina',
        currencies: [
            PAYOUTS_CURRENCIES['ARS'],
        ]
    },
    'AU': {
        name: 'Australia',
        currencies: [
            PAYOUTS_CURRENCIES['AUD'],
        ]
    },
    'AT': {
        name: 'Austria',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'BE': {
        name: 'Belgium',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'BO': {
        name: 'Bolivia',
        currencies: [
            PAYOUTS_CURRENCIES['BOB'],
        ]
    },
    'BR': {
        name: 'Brazil',
        currencies: [
            PAYOUTS_CURRENCIES['BRL'],
        ]
    },
    'BG': {
        name: 'Bulgaria',
        currencies: [
            PAYOUTS_CURRENCIES['BGN'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'CA': {
        name: 'Canada',
        currencies: [
            PAYOUTS_CURRENCIES['CAD'],
            PAYOUTS_CURRENCIES['USD'],
        ]
    },
    'CL': {
        name: 'Chile',
        currencies: [
            PAYOUTS_CURRENCIES['CLP'],
        ]
    },
    'CO': {
        name: 'Columbia',
        currencies: [
            PAYOUTS_CURRENCIES['COP'],
        ]
    },
    'CR': {
        name: 'Costa Rica',
        currencies: [
            PAYOUTS_CURRENCIES['CRC'],
        ]
    },
    'HR': {
        name: 'Croatia',
        currencies: [
            PAYOUTS_CURRENCIES['HRK'],
            PAYOUTS_CURRENCIES['EUR'],
        ]
    },
    'CY': {
        name: 'Cyprus',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'CZ': {
        name: 'Czech Republic',
        currencies: [
            PAYOUTS_CURRENCIES['CZK'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'DK': {
        name: 'Denmark',
        currencies: [
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'DO': {
        name: 'Dominican Republic',
        currencies: [
            PAYOUTS_CURRENCIES['DOP'],
        ]
    },
    'EG': {
        name: 'Egypt',
        currencies: [
            PAYOUTS_CURRENCIES['EGP'],
        ]
    },
    'EE': {
        name: 'Estonia',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'FI': {
        name: 'Finland',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'FR': {
        name: 'France',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'DE': {
        name: 'Germany',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'GR': {
        name: 'Greece',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'HK': {
        name: 'Hong Kong',
        currencies: [
            PAYOUTS_CURRENCIES['HKD'],
        ]
    },
    'HU': {
        name: 'Hungary',
        currencies: [
            PAYOUTS_CURRENCIES['HUF'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'IS': {
        name: 'Iceland',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
        ]
    },
    'IN': {
        name: 'India',
        currencies: [
            PAYOUTS_CURRENCIES['INR'],
        ]
    },
    'ID': {
        name: 'Indonesia',
        currencies: [
            PAYOUTS_CURRENCIES['IDR'],
        ]
    },
    'IE': {
        name: 'Ireland',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'IL': {
        name: 'Israel',
        currencies: [
            PAYOUTS_CURRENCIES['ILS'],
        ]
    },
    'IT': {
        name: 'Italy',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'JP': {
        name: 'Japan',
        currencies: [
            PAYOUTS_CURRENCIES['JPY'],
        ]
    },
    'LV': {
        name: 'Latvia',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'LI': {
        name: 'Liechtenstein',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'LT': {
        name: 'Lithuania',
        currencies: [
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'LU': {
        name: 'Luxembourg',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'MY': {
        name: 'Malaysia',
        currencies: [
            PAYOUTS_CURRENCIES['MYR'],
        ]
    },
    'MT': {
        name: 'Malta',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'MX': {
        name: 'Mexico',
        currencies: [
            PAYOUTS_CURRENCIES['MXN'],
        ]
    },
    'NL': {
        name: 'Netherlands',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'NZ': {
        name: 'New Zealand',
        currencies: [
            PAYOUTS_CURRENCIES['NZD'],
        ]
    },
    'NO': {
        name: 'Norway',
        currencies: [
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'PY': {
        name: 'Paraguay',
        currencies: [
            PAYOUTS_CURRENCIES['PYG'],
        ]
    },
    'PE': {
        name: 'Peru',
        currencies: [
            PAYOUTS_CURRENCIES['PEN'],
        ]
    },
    'PL': {
        name: 'Poland',
        currencies: [
            PAYOUTS_CURRENCIES['PLN'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'PT': {
        name: 'Portugal',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'RO': {
        name: 'Romania',
        currencies: [
            PAYOUTS_CURRENCIES['RON'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'SG': {
        name: 'Singapore',
        currencies: [
            PAYOUTS_CURRENCIES['SGD'],
        ]
    },
    'SK': {
        name: 'Slovakia',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'SI': {
        name: 'Slovenia',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'ES': {
        name: 'Spain',
        currencies: [
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'SE': {
        name: 'Sweden',
        currencies: [
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'CH': {
        name: 'Switzerland',
        currencies: [
            PAYOUTS_CURRENCIES['CHF'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['GBP'],
        ]
    },
    'TH': {
        name: 'Thailand',
        currencies: [
            PAYOUTS_CURRENCIES['THB'],
        ]
    },
    'TT': {
        name: 'Trinidad & Tobago',
        currencies: [
            PAYOUTS_CURRENCIES['TTD'],
        ]
    },
    'AE': {
        name: 'United Arab Emirates',
        currencies: [
            PAYOUTS_CURRENCIES['AED'],
        ]
    },
    'GB': {
        name: 'United Kingdom',
        currencies: [
            PAYOUTS_CURRENCIES['GBP'],
            PAYOUTS_CURRENCIES['EUR'],
            PAYOUTS_CURRENCIES['USD'],
            PAYOUTS_CURRENCIES['SEK'],
            PAYOUTS_CURRENCIES['NOK'],
            PAYOUTS_CURRENCIES['DKK'],
            PAYOUTS_CURRENCIES['CHF'],
        ]
    },
    'US': {
        name: 'United States',
        currencies: [
            PAYOUTS_CURRENCIES['USD'],
        ]
    },
    'UY': {
        name: 'Uruguay',
        currencies: [
            PAYOUTS_CURRENCIES['UYU'],
        ]
    },
};
